import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import LandingPage from "./pages/LandingPage";
import CreatePage from "./pages/CreatePage";
import WaitlistPage from "./pages/WaitlistPage";
import LoginPage from "./pages/LoginPage";
import AuthVerifyPage from "./pages/AuthVerifyPage";
import ConfirmEmailPage from "./pages/ConfirmEmailPage";
import EditorPage from "./pages/EditorPage";
import PublicProfilePage from "./pages/PublicProfilePage";
import AdminPage from "./pages/AdminPage";
import DealInboxPage from "./pages/DealInboxPage";

// Apps
import { PitchFormPage } from "./components/apps";
import MeetingRedirectPage from "./components/apps/MeetingRedirectPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/waitlist" element={<WaitlistPage />} />
          <Route path="/create" element={<Navigate to="/waitlist" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/verify" element={<AuthVerifyPage />} />
          <Route path="/auth/confirm-email" element={<ConfirmEmailPage />} />
          <Route path="/editor" element={<EditorPage />} />
          <Route path="/deals" element={<DealInboxPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/edit/:pageId" element={<EditorPage />} />
          <Route path="/p/:slug" element={<PublicProfilePage />} />
          <Route path="/p/:slug/app/:appType" element={<PitchFormPage />} />
          <Route path="/p/:slug/meet/:privateCode" element={<MeetingRedirectPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </AuthProvider>
  );
}

export default App;
